const enumQuestionResponseStatus = {
  NOT_ANSWERED: 1,
  PARTIAL: 2,
  YES: 3,
  NO: 4,
};

export default enumQuestionResponseStatus;
